import {
  PUSH_DEEPLINK_GROUPS,
  pushDeeplinkPath,
} from '@/lib/push-deeplinks';

export function PushDeeplinkField({
  value,
  onChange,
}: {
  value: string;
  onChange: (value: string) => void;
}) {
  const path = pushDeeplinkPath(value);

  return (
    <div>
      <label className="mb-1 block text-sm text-gray-500">
        Deeplink <span className="text-gray-400">(optional)</span>
      </label>
      <select
        className="w-full rounded-xl border border-gray-200 px-3 py-2 text-sm"
        value={value}
        onChange={(event) => onChange(event.target.value)}
      >
        <option value="">None — open app without navigation</option>
        {PUSH_DEEPLINK_GROUPS.map((group) => (
          <optgroup key={group.label} label={group.label}>
            {group.options.map((option) => (
              <option key={option.key} value={option.key}>
                {option.label}
              </option>
            ))}
          </optgroup>
        ))}
      </select>
      {path ? (
        <p className="mt-1 text-xs text-gray-500">
          Opens <code className="rounded bg-gray-100 px-1">{path}</code>
        </p>
      ) : null}
    </div>
  );
}
